import React, { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

/** Escape the table's isolated stacking context and viewport clipping. */
export const CardFlightLayer: FC<PropsWithChildren> = ({ children }) =>
  createPortal(
    <div
      data-testid="opponent-card-flight"
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2400,
        pointerEvents: 'none',
      }}
    >
      {children}
    </div>,
    document.body
  );
